import React from 'react';
import Marquee from 'react-fast-marquee';

const items = [
  'NUEVA NORMATIVA 2026: FICHAJE DIGITAL OBLIGATORIO',
  'ADIÓS AL PAPEL Y AL EXCEL',
  'MULTAS DE HASTA 10.000 € POR TRABAJADOR',
  'ACCESO REMOTO DE LA INSPECCIÓN DE TRABAJO',
  'REGISTROS INALTERABLES Y TRAZABLES',
  'CONSERVACIÓN DE REGISTROS DURANTE 4 AÑOS',
];

export const LegalMarquee = () => (
  <div className="bg-forest-900 py-3.5 noise-overlay" data-testid="legal-marquee">
    <Marquee speed={35} gradient={false} autoFill>
      {items.map((t) => (
        <span key={t} className="font-body-landing text-bone/80 text-xs sm:text-sm font-semibold tracking-[0.18em] mx-8 flex items-center gap-8">
          {t}
          <span className="w-1.5 h-1.5 rounded-full bg-terracotta inline-block" />
        </span>
      ))}
    </Marquee>
  </div>
);
